import React, { Component, useState } from "react";
import { Rating } from 'react-simple-star-rating'
import { Link, withRouter } from "react-router-dom";



const University_detail = () => {

    const [ratingValue, setRatingValue] = useState(0) // initial rating v
    const handleRating = (rate) => {
        setRatingValue(rate)
    }
    const handleReset = () => {
        setRatingValue(4)
    }


    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 2000,
        slidesToShow: 3,
        adaptiveHeight: true,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 770,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            }
        ]
    };

    return (
        <div>
            <div className="university_area">
                <div className="inner_area">
                    <div className="rating_area">
                        <Rating
                            ratingValue={ratingValue}
                            showTooltip={true}
                            initialValue={3.8}
                            readonly
                            tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                        />
                    </div>
                    <div className="university_detail_area">
                        <div className="left_area">
                            <h1>
                                Penn State University
                            </h1>
                        </div>
                        <div className="right_area">
                            <button className="btn-primary-2" >Apply Now</button>
                        </div>
                        <div className="des_area">
                            <p>The Pennsylvania State University is a public state-related land-grant research
                                university with campuses and facilities throughout Pennsylvania<Link to='/#1'>...more</Link></p>
                        </div>
                    </div>
                    <div className="table_area">
                        <ul>
                            <li>
                                <Link to='/#'> <i class="far fa-map-marker-alt"></i> State College, PA 16801, United States</Link>
                            </li>
                            <li className="web_link">
                                <Link to='/#'> <i class="far fa-globe"></i> www.pennstate.edu</Link>
                            </li>
                            <li>
                                <Link to='/#'> <i class="far fa-at"></i> Penstateuni@samplemail.com</Link>
                            </li>
                            <li>
                                <Link to='/#'> <i class="far fa-phone-alt"></i> 123-4567-8910, 1245-22-5468</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="row">
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                            <div className="box_detail_area">
                                <div className="box_area">
                                    <div className="icon_area">
                                        <i class="fal fa-dollar-sign"></i>
                                    </div>
                                    <h5>$27k</h5>
                                    <p>Avg cost after aid</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                            <div className="box_detail_area">
                                <div className="box_area">
                                    <div className="icon_area">
                                        <i class="far fa-graduation-cap"></i>
                                    </div>
                                    <h5>68%</h5>
                                    <p>Graduation rate</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                            <div className="box_detail_area">
                                <div className="box_area">
                                    <div className="icon_area">
                                        <i class="far fa-user-check"></i>
                                    </div>
                                    <h5><i class="far fa-minus"></i></h5>
                                    <p>Acceptance rate</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                            <div className="box_detail_area">
                                <div className="box_area">
                                    <div className="icon_area">
                                        <i class="far fa-user-friends"></i>
                                    </div>
                                    <h5>5000+</h5>
                                    <p>Students</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default University_detail;







































